import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import combineReducer from "./combineReducer";

const persistConfig = {
  key: "admin-root",
  storage,
  whitelist: ["authAdminReducer"],
  blacklist: ["commonReducer"],
};

const persistedReducer = persistReducer(persistConfig, combineReducer);

const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export default store;
